import eventDetail from './event-detail'

export default eventDetail
